import gql from "graphql-tag";

export const GET_VIEWER_QUERY = gql`
  query getViewerQuery {
    viewer {
      id
      name
      email
      userId
      lastName
      username
        firstName
        wishListProducts
        showCategories {
        id
        databaseId
        name
        slug
        termGroupId
        description
        parentId
        count
        menuOrder
      }
      showPriceCategories {
        id
        databaseId
        name
        slug
        termGroupId
        description
        parentId
        count
        menuOrder
      }
    }
  }
`;

export const GET_USER_ADDRESSES_QUERY = gql`
  query getUserAddressesQuery($customerId: Int) {
    customer(customerId: $customerId) {
      billing {
        address1
        city
        firstName
        lastName
        phone
        country
      }
      shipping {
        address1
        city
        firstName
        lastName
        phone
        country
      }
    }
  }
`;
